"use client"

import { Button, Card, Col, Layout, Row } from "antd"
import { useEffect, useState } from "react"

const { Content } = Layout

type Video = {
  titulo: string
  videoUrl: string
}

// Função para extrair o ID do vídeo de um link do YouTube (normal ou shorts)
const extrairVideoId = (url: string): string => {
  // Para links de shorts
  if (url.includes("youtube.com/shorts/")) {
    const match = url.match(/youtube\.com\/shorts\/([^?&]+)/)
    if (match && match[1]) {
      return match[1]
    }
  }

  // Para links normais do YouTube
  if (url.includes("youtube.com/watch")) {
    const urlObj = new URL(url)
    return urlObj.searchParams.get("v") || ""
  }

  return ""
}

const videos: Video[] = [
  {
    titulo: "Pietra Naturale Durafix, Textura de Pedras Naturais",
    videoUrl: "https://youtube.com/shorts/vuMG7_p-5c8?si=yvKSxruMLOqePJFl",
  },
  {
    titulo: "Borracha Líquida Durafix",
    videoUrl: "https://youtube.com/shorts/BuR9H1r3smw?si=70gVJUSxtKuFsK6S",
  },
  {
    titulo: "Super Manta Líquida Durafix",
    videoUrl: "https://youtube.com/shorts/zvzvXz0_mEY?si=aEmB9tcE8cGaVpfT",
  },
  {
    titulo: "Parede Flex e Tinta Borracha Liquida Durafix",
    videoUrl: "https://youtube.com/shorts/730y1g0-UU8?si=x8JQJak_ffMsnWF6",
  },
  {
    titulo: "Conheça a Textura Granulatto Durafix",
    videoUrl: "https://youtube.com/shorts/2oVXkTH2AMY?si=KMJaz1N7tOK8m6ys",
  },
]

export default function VideosPage() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener("resize", handleResize)
    handleResize() // Chama uma vez para definir o estado inicial

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Layout>
      <Content className="content">
        <div className="container">
          {/* Lista de vídeos */}
          <div className="categoria">
            <h2
              className="categoria-titulo"
              style={{
                backgroundColor: "#0647bd",
                color: "#fff",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                margin: 0,
                paddingLeft: "20px",
              }}
            >
              Vídeos DURAFIX
            </h2>
            <Row gutter={[16, 16]} style={{ padding: "20px" }}>
              {videos.map((video, i) => (
                <Col key={i} xs={24} sm={12} md={8} lg={8}>
                  <Card
                    style={{
                      textAlign: "center",
                      padding: "15px",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    bodyStyle={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      padding: 0,
                    }}
                  >
                    {/* Container centralizado para o vídeo */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "10px",
                      }}
                    >
                      {/* Player de vídeo incorporado com dimensões reduzidas */}
                      <div
                        style={{
                          position: "relative",
                          width: "80%", // Reduzido para 80% da largura do card
                          maxWidth: "240px", // Largura máxima para manter consistência
                          margin: "0 auto",
                        }}
                      >
                        <div
                          style={{
                            paddingBottom: "177.77%", // Proporção 9:16 para vídeos verticais (Shorts)
                            height: 0,
                            overflow: "hidden",
                            borderRadius: "8px", // Bordas arredondadas
                          }}
                        >
                          <iframe
                            src={`https://www.youtube.com/embed/${extrairVideoId(video.videoUrl)}`}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              border: "none",
                            }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={video.titulo}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Título */}
                    <div style={{ padding: "0 5px", marginBottom: "10px" }}>
                      <h3 style={{ fontSize: "14px", margin: "10px 0", textAlign: "center" }}>{video.titulo}</h3>
                    </div>

                    {/* Botão de assistir */}
                    {/* <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0647bd",
                        borderColor: "#0647bd",
                        color: "#fff",
                        width: "100%",
                        marginTop: "auto",
                      }}
                      onClick={() => window.open(video.videoUrl, "_blank")}
                    >
                      ASSISTIR VÍDEO
                    </Button> */}
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </Content>
    </Layout>
  )
}
